import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import 'vuetify/styles';
import i18n from './i18n';
import './assets/css/global.css';
import './assets/css/fonts.css';
import AppConfigStore from '@/stores/config/app-config-module';
import setupInterceptors from '@/plugins/axios';
import setupLeaflet from '@/plugins/leaflet';

setupInterceptors();
setupLeaflet();

function mountApp() {
  try {
    const app = createApp(App);

    app.use(router);
    app.use(vuetify);
    app.use(i18n);

    app.directive('show-important', {
      mounted(el, binding) {
        if (binding.value === false) {
          el.style.setProperty('display', 'none', 'important');
        } else {
          el.style.display = '';
        }
      },
      updated(el, binding) {
        if (binding.value === false) {
          el.style.setProperty('display', 'none', 'important');
        } else {
          el.style.display = '';
        }
      },
    })

    app.mount('#app');
  } catch {
    displayLoadingError('The application could not be mounted.');
  }
}

function displayLoadingError(msg: string) {
  const appElement = document.getElementById('app');
  if (appElement) {
    appElement.innerHTML = `An error occurred while loading the web application: ${msg}`;
  }
}

AppConfigStore.fetchAppConfig().then(() => mountApp());
